import {
  K2CrossrailEngineeringSchema,
  K2CrossRailSchema,
  K2Schema,
  K2SimpleTiltEngineeringSchema,
  K2SimpleTiltSchema,
} from './K2APISchema'
import { railSystemEnum } from './K2HelperFunctions'
import { K2MountingSystemName, K2RailType } from './K2Types'

type RailSystem = typeof railSystemEnum[number]

type K2RailConfig = {
  mountingSystemName: K2MountingSystemName
  railSystem: RailSystem
  inputSchema: K2Schema
  engineeringSchema: K2Schema
}

export const K2RailRegistry: Record<K2RailType, K2RailConfig> = {
  crossrail: {
    mountingSystemName: 'k2OnRoof',
    railSystem: 'CROSSRAIL',
    inputSchema: K2CrossRailSchema,
    engineeringSchema: K2CrossrailEngineeringSchema,
  },
  simpleTilt: {
    mountingSystemName: 'k2SimpleTilt',
    railSystem: 'SIMPLE_TILT_US',
    inputSchema: K2SimpleTiltSchema,
    engineeringSchema: K2SimpleTiltEngineeringSchema,
  },
}

export function getK2Config(railType: K2RailType) {
  return K2RailRegistry[railType]
}
